import AssignmentPrioritySelectorContainer from './containers/AssignmentPrioritySelectorContainer'

export default AssignmentPrioritySelectorContainer
